// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6020fea3","455":"c142c66f","977":"3bb336ed"}[chunkId] + ".chunk.js";
};